const config = {
    // baseUrl: "http://localhost:5197/api",
   baseUrl: "https://projectsapi.zicorp.co.in/api",
};

export default config;
